import React from 'react'
import Headerr from '../Global/Headerr'
import Bredcrumbb from '../Mainfaq/Bredcrumbb'
import Downloadapp from '../Global/Downloadapp'
import Cta from '../Global/Cta'
import Footer from '../Global/Footer'
import Faqsection from '../Mainfaq/Faqsection'

const main = () => {
  return (
    <div>
      <Headerr/>
      <Bredcrumbb/>
      <Faqsection/>
      <Downloadapp/>
      <Cta/>
      <Footer/>
      
    </div>
  )
}

export default main
